// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Tib8","bigColWidth":"Table_bigColWidth__3hr04","biggerColWidth":"Table_biggerColWidth__2etgR","row":"Table_row__2DTL4","col":"Table_col__msH6O"};